export const TARGET_SAMPLE_RATE = 48000;
